import { render } from "./ToDoPhaseAddMemberTask.vue?vue&type=template&id=5d6b06b8&ts=true"
import script from "./ToDoPhaseAddMemberTask.vue?vue&type=script&lang=ts"
export * from "./ToDoPhaseAddMemberTask.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__